<template>
  <div>
    <div class="row">
      <div class="col-3 offset-9">
        <button class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="selectField($event)">
          <i class="fas fa-chevron-left"></i>&nbsp;&nbsp;Seleccionar Campo
        </button>
      </div>
    </div>

    <h5 class="text-center info-text">Complete la información básica del Campo, y pulse SIGUIENTE para crearlo</h5>

    <div class="row justify-content-center mt-4">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label"> Nombre (*) </label>

          <el-input
            v-model="formData.name"
            v-validate="modelValidations.name"
            name="name"
            placeholder="Nombre"
            suffix-icon="fas fa-map"
          >
          </el-input>

          <small v-show="name.invalid" class="text-danger">
            {{ getError('name') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> Dirección </label>

          <el-input
            v-model="formData.address"
            v-validate="modelValidations.address"
            name="address"
            placeholder="Dirección"
            suffix-icon="fas fa-map-signs"
          >
          </el-input>

          <small v-show="address.invalid" class="text-danger">
            {{ getError('address') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> Superficie </label>

          <el-input
            v-model="formData.hectares"
            v-validate="modelValidations.hectares"
            name="hectares"
            placeholder="Superficie"
            suffix-icon="fas fa-globe-americas"
          >
          </el-input>

          <small v-show="hectares.invalid" class="text-danger">
            {{ getError('hectares') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> Provincia (*) </label>

          <el-select
            v-model="formData.province"
            v-validate="modelValidations.province"
            autocomplete="off"
            filterable
            name="province"
            placeholder="Provincia"
            @change="clearCity"
          >
            <el-option
              v-for="option in provincesOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>

          <small v-show="province.invalid" class="text-danger">
            {{ getError('province') }}
          </small>
        </div>

        <div class="form-group">
          <label class="control-label"> Localidad (*) </label>

          <el-autocomplete
            v-model="formData.cityName"
            v-validate="modelValidations.city"
            :disabled="!formData.province"
            name="city"
            class="w-100"
            placeholder="Localidad"
            :fetch-suggestions="querySearchAsync"
            @select="selectCity"
          >
          </el-autocomplete>

          <small v-show="searchError !== ''" class="text-danger d-block">
            {{ searchError }}
          </small>

          <small v-show="city.invalid" class="text-danger">
            {{ getError('city') }}
          </small>
        </div>

        <div class="row justify-content-center">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label"> Latitud </label>

              <el-input
                v-model="formData.latitude"
                disabled
                name="latitude"
                placeholder="Latitud"
                suffix-icon="fas fa-map-marker-alt"
              >
              </el-input>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label"> Longitud </label>

              <el-input
                v-model="formData.longitude"
                disabled
                name="longitude"
                placeholder="Longitud"
                suffix-icon="fas fa-map-marker-alt"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <field-map
          map-id="field-map"
          :zoom="6"
          :entity="formData"
          :latitude.sync="formData.latitude"
          :longitude.sync="formData.longitude"
          :title="formData.name"
          entity-type="campo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Autocomplete, Select, Option } from 'element-ui';
import cityProvinceOptionsMixin from '@/mixins/cityProvinceOptionsMixin';
import FieldMap from '@/views/Plots/Widgets/Map';

export default {
  components: {
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
    FieldMap,
  },

  mixins: [cityProvinceOptionsMixin],
  data() {
    return {
      formData: {
        id: null,
        name: null,
        address: '',
        hectares: null,
        latitude: null,
        longitude: null,
        province: null,
        city: null,
        cityName: null,
        producer: null,
      },

      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        address: {},
        hectares: {
          numeric: true,
          min: 0,
        },

        province: {
          required: true,
        },

        city: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'hectares', 'address', 'city', 'province']),
  },

  methods: {
    selectField(e) {
      this.$emit('selectField', e);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    create(producer) {
      this.formData.producer = producer;
      return this.$services.resource('fields').create(this.formData);
    },
  },
};
</script>
